<template>
  <v-layout class="lookup-images-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="11" class="py-0">
          <v-row>
            <v-col cols="12" md="6" lg="4">
              <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 2 : 0">
                  <v-card-title>Restaurantes activos por vencer</v-card-title>
                  <v-card-subtitle
                    >Restaurantes por vencer con pedidos en la última
                    semana</v-card-subtitle
                  >
                  <v-card-text v-if="!expiring">
                    <v-skeleton-loader type="list-item-avatar-two-line" tile />
                    <v-skeleton-loader type="list-item-avatar-two-line" tile />
                  </v-card-text>
                  <v-card-text v-else>
                    <div>
                      <perfect-scrollbar
                        class="ps--scroll-y-always pr-3"
                        style="max-height: 380px"
                        :options="{
                          suppressScrollX: true,
                          wheelPropagation: false,
                        }"
                      >
                        <div
                          class="d-flex justify-space-between align-center mb-2"
                          v-for="r of expiring"
                          :key="r.id"
                        >
                          <v-img
                            class="logo mr-2"
                            :max-width="imgSize"
                            :max-height="imgSize"
                            :width="imgSize"
                            :height="imgSize"
                            style="border-radius: 8px; overflow: hidden"
                            :src="
                              r.logo
                                ? `${uploadsPath}/${r.logo}`
                                : `assets/img/restaurant-logo.png`
                            "
                          ></v-img>
                          <div class="d-flex flex-column">
                            <div class="children-inline">
                              <h3>{{ r.name }}</h3>
                              <v-btn
                                icon
                                x-small
                                :href="`https://${domain}/${r.stringId}`"
                                target="_blank"
                                ><v-icon>mdi-link-variant</v-icon></v-btn
                              >
                            </div>
                            <span class="font-size-9e grey--text">
                              Vence
                              <timeago
                                :datetime="r.planExpiresAt"
                                :auto-update="60"
                              ></timeago>
                              | {{ r.ordersLastWeek }} pedidos última semana
                            </span>
                          </div>
                          <v-spacer />
                          <div class="children-inline">
                            <v-btn
                              v-if="r.userWhatsapp"
                              color="green"
                              dark
                              rounded
                              small
                              class="px-2"
                              style="padding-top: 2px"
                              target="_blank"
                              v-tooltip.bottom="'Whatsapp del usuario'"
                              :href="`https://wa.me/${r.userWhatsapp.replace(
                                '+',
                                ''
                              )}?text=${getWhatsappMessage(r)}`"
                            >
                              <v-icon small>mdi-account</v-icon>
                              <v-icon>mdi-whatsapp</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="r.ordersWhatsapp || r.whatsapp"
                              color="green"
                              dark
                              rounded
                              small
                              class="px-2"
                              style="padding-top: 2px"
                              target="_blank"
                              v-tooltip.bottom="'Whatsapp de la tienda'"
                              :href="`https://wa.me/${(
                                r.ordersWhatsapp || r.whatsapp
                              ).replace('+', '')}?text=${getWhatsappMessage(
                                r
                              )}`"
                            >
                              <v-icon small>mdi-store</v-icon>
                              <v-icon>mdi-whatsapp</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </perfect-scrollbar>
                    </div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="6" lg="8">
              <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 2 : 0">
                  <v-card-title>Ubicación de restaurantes</v-card-title>
                  <v-card-subtitle
                    >Ubicación de los
                    <strong v-if="locations">{{ locations.length }} </strong
                    >restaurantes activos en la última semana</v-card-subtitle
                  >
                  <v-card-text v-if="!locations">
                    <v-skeleton-loader type="paragraph" tile />
                  </v-card-text>
                  <v-card-text v-else>
                    <div
                      class=""
                      style="height: 380px; width: 100%; position: relative"
                    >
                      <l-map
                        ref="myMap"
                        :zoom="mapZoom"
                        :center="mapCenter"
                        @ready="onMapReady"
                        @update:center="mapCenterUpdated"
                        @update:zoom="mapZoomUpdated"
                        @update:bounds="mapBoundsUpdated"
                      >
                        <l-tile-layer
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <l-marker
                          v-for="(group, index) of groupedLocations"
                          :key="
                            group.items.length === 1
                              ? group.items[0].id
                              : group.lat +
                                '|' +
                                group.lng +
                                '|' +
                                group.items.length +
                                '|' +
                                index
                          "
                          :lat-lng="group"
                        >
                          <l-popup v-if="group.items.length > 1"
                            >{{ group.items.length }} tiendas</l-popup
                          >
                          <l-popup
                            v-else-if="selectedMarkerId !== group.items[0].id"
                            :data-restaurant-id="group.items[0].id"
                            :options="{
                              minWidth: 200,
                              maxWidth: 500,
                            }"
                          >
                            <span></span>
                          </l-popup>
                          <l-popup
                            v-else
                            :data-restaurant-id="group.items[0].id"
                            :options="{
                              minWidth: 200,
                              maxWidth: 500,
                            }"
                          >
                            <map-popup-restaurant
                              :restaurant-id="group.items[0].id"
                            />
                          </l-popup>
                        </l-marker>
                      </l-map>
                    </div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 2 : 0">
                  <v-card-title>Restaurantes</v-card-title>
                  <v-card-subtitle
                    >Visualize resumidamente todos los restaurantes
                    registrados</v-card-subtitle
                  >
                  <v-card-text>
                    <restaurant-list :user="user" />
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import RestaurantsService from '../../../api/services/restaurants.service';
  import { IExpiringRestaurant } from '../../../interfaces/IExpiringRestaurant';
  import { Globals } from '../../../modules/Globals';
  import { vueData } from '../../../VueData';
  import { IActiveLocation } from '../../../interfaces/IActiveLocation';
  import { debounce } from '../../../utils';
  import MapPopupRestaurant from '../../widgets/MapPopupRestaurant.vue';
  import { IRestaurant } from '../../../interfaces/IRestaurant';
  import { IPaginated } from '../../../interfaces/IPaginated';
  import RestaurantList from './widgets/RestaurantList.vue';
  import { IUser } from '../../../interfaces/IUser';
  import { getTopLevelDomain } from '@/utils/domain.utils';

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
  @Component({
    components: { RestaurantList, MapPopupRestaurant },
  })
  export default class AdminDashboard extends Vue {
    $refs: {
      myMap: any;
    };
    @Prop() user: IUser;
    restaurantService = new RestaurantsService();
    expiring: IExpiringRestaurant[] = null;
    locations: IActiveLocation[] = null;
    uploadsPath = Globals.uploadsPath;
    imgSize = 50;
    whatsappMessage =
      'Hola! Soy Federico de QueResto.com. Me comunico para avisar que su plan en la plataforma está próximo a vencer. Si quiere seguir recibiendo pedidos, no se olvide de renovarlo!\r\n\r\n';
    zoom = 10000;
    mapCenter = [37.71859032558816, 15.5];
    zooms = {};
    bounds = null;
    setBounds = null;
    selectedMarkerId = null;
    domain = getTopLevelDomain();

    getWhatsappMessage(r: IRestaurant) {
      return encodeURIComponent(
        this.whatsappMessage +
          `Puede renovar el plan desde aquí https://${this.domain}/admin/${r.stringId}/settings?tab=plan`
      );
    }

    async created() {
      for (let i = 0; i < 30; i++) {
        this.zooms[this.calcZoom(i)] = i;
      }

      this.setBounds = debounce((bounds) => {
        this.bounds = bounds;
      }, 250);

      this.loadExpiring();
      this.loadActiveLocations();
    }

    onMapReady() {
      this.$refs.myMap.mapObject.invalidateSize();
      this.$refs.myMap.mapObject.on('popupopen', (event) => {
        this.selectedMarkerId = event.popup._content.dataset.restaurantId
          ? +event.popup._content.dataset.restaurantId
          : null;
      });
    }

    mapCenterUpdated(center) {
      this.mapCenter = center;
    }

    mapZoomUpdated(zoom) {
      this.mapZoom = zoom;
    }

    mapBoundsUpdated(bounds) {
      this.setBounds(bounds);
    }

    get mapZoom() {
      return this.zooms[this.zoom];
    }

    set mapZoom(val: number) {
      this.zoom = this.calcZoom(val);
    }

    calcZoom(level: number) {
      return 20000 / Math.pow(2, level);
    }

    async loadExpiring() {
      this.expiring = null;
      try {
        const expiring = await this.restaurantService.getExpiringRestaurants();
        this.expiring = expiring;
      } catch (e) {
        vueData.serverError(e);
      }
    }

    async loadActiveLocations() {
      this.locations = null;
      try {
        const locations = await this.restaurantService.getActiveLocations();
        this.locations = locations;
      } catch (e) {
        vueData.serverError(e);
      }
    }

    get groupedLocations() {
      if (!this.locations) return null;

      const zoom = this.zoom,
        bounds = this.bounds,
        groupRadio = this.zoom > 0.1 ? this.zoom / 10 / 2 : 0,
        groups: Array<{
          lat: number;
          lng: number;
          items: IActiveLocation[];
        }> = [];

      function findGroup(lat, lng) {
        let group =
          groupRadio > 0
            ? groups.find(
                (g) =>
                  getDistanceFromLatLonInKm(lat, lng, g.lat, g.lng) <=
                  groupRadio
              )
            : null;

        if (!group) {
          group = {
            lat,
            lng,
            items: [],
          };
          groups.push(group);
        }
        return group;
      }

      function insideBounds(lat, lng) {
        return (
          !bounds ||
          (lng <= bounds.getEast() &&
            lng >= bounds.getWest() &&
            lat <= bounds.getNorth() &&
            lat >= bounds.getSouth())
        );
      }

      function averageLatLng(group) {
        let lat = 0,
          lng = 0;

        for (const i of group.items) {
          lat += i.lat;
          lng += i.lng;
        }

        lat /= group.items.length;
        lng /= group.items.length;

        return { lat, lng };
      }

      for (const loc of this.locations) {
        if (!insideBounds(loc.lat, loc.lng)) continue;

        const group = findGroup(loc.lat, loc.lng);
        group.items.push(loc);
      }

      for (const group of groups) {
        const avg = averageLatLng(group);
        group.lat = avg.lat;
        group.lng = avg.lng;
      }

      return groups;
    }
  }
</script>
